<template>
  <TooltipProvider :delay-duration="0">
    <TooltipRoot :open="show && isOpen">
      <TooltipTrigger :class="[show ? 'cursor-pointer' : '']" as-child @mouseenter="setOpen" @mouseleave="setOpen">
        <slot name="trigger"></slot>
      </TooltipTrigger>

      <TooltipPortal>
        <TooltipContent
          :side="side"
          :align="align"
          class="z-[20] max-w-[260px] rounded-md border-1 border-solid border-light-gray bg-white px-2 py-1 text-xs text-theme-1"
          :side-offset="sideOffset"
          as-child
        >
          <slot name="content"></slot>
        </TooltipContent>
      </TooltipPortal>
    </TooltipRoot>
  </TooltipProvider>
</template>

<script setup lang="ts">
import { TooltipContent, TooltipPortal, TooltipProvider, TooltipRoot, TooltipTrigger } from "radix-vue";
import { PropType, ref } from "vue";

type TooltipContentProps = InstanceType<typeof TooltipContent>["$props"];

defineProps({
  side: { type: String as PropType<TooltipContentProps["side"]>, required: false },
  align: { type: String as PropType<TooltipContentProps["align"]>, required: false },
  sideOffset: { type: Number as PropType<TooltipContentProps["sideOffset"]>, required: false },
  show: { type: Boolean, required: false, default: true },
});

const isOpen = ref(false);
const setOpen = () => (isOpen.value = !isOpen.value);
</script>
